import { useEffect } from "react";
import { useLocation, useNavigate } from "@tanstack/react-router";
import { usePrivy } from "@privy-io/react-auth";

const FIRST_LOGIN_HOME_REDIRECT_KEY_PREFIX = "cfl:first-login-home-redirected";

export function FirstLoginRedirect() {
  const { ready, authenticated, user } = usePrivy();
  const navigate = useNavigate();
  const location = useLocation();
  const walletAddress = user?.wallet?.address;
  const redirectKey = walletAddress
    ? `${FIRST_LOGIN_HOME_REDIRECT_KEY_PREFIX}:${walletAddress.toLowerCase()}`
    : null;

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!ready || !authenticated || !redirectKey) return;
    if (window.localStorage.getItem(redirectKey)) return;

    window.localStorage.setItem(redirectKey, "1");

    if (location.pathname !== "/home") {
      navigate({ to: "/home", replace: true });
    }
  }, [authenticated, navigate, location.pathname, ready, redirectKey]);

  return null;
}
